import { render, staticRenderFns } from "./agency.vue?vue&type=template&id=17219a66"
import script from "./agency.vue?vue&type=script&lang=js"
export * from "./agency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17219a66')) {
      api.createRecord('17219a66', component.options)
    } else {
      api.reload('17219a66', component.options)
    }
    module.hot.accept("./agency.vue?vue&type=template&id=17219a66", function () {
      api.rerender('17219a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/updatePassWord/agency.vue"
export default component.exports